export default {
  BT_HDP: "让球",
  BT_OU: "大/小",
  BT_ML: "胜负盘",
  BT_1X2: "独赢",
  BT_1X2HDP: "三项让分投注",
  BT_CS: "波胆",
  BT_OE: "单/双",
  BT_DC: "双重机会",
  BT_HTFT: "半场/全场",
  BT_FGLG: "最先进球/最后进球",
  BT_TG: "总进球",
  BT_OR: "优胜冠军",
  BT_ORZ: "优胜冠军",

  BT_ANB: "客场无效",
  BT_BS: "双方/一方/两者皆不得分",
  BT_CL: "零失球",
  BT_DNB: "获胜球队",
  BT_DNBH: "上半场获胜球队",
  BT_HNB: "主场无效",
  BT_TWTN: "零失球的胜方",

  BT_HDPF: "全场让球",
  BT_OUF: "全场大",
  BT_MLF: "全场胜负盘",
  BT_1X2F: "全场独赢",
  BT_1X2HDPF: "全场三项让分投注",
  BT_CSF: "全场波胆",
  BT_OEF: "全场单",
  BT_DCF: "全场双重机会",
  BT_FGLGF: "全场最先进球/最后进球",
  BT_TGF: "全场总进球",

  BT_HDPH: "上半场让球",
  BT_OUH: "上半场大/小",
  BT_MLH: "上半场胜负盘",
  BT_1X2H: "上半场独赢",
  BT_1X2HDPH: "上半场三项让分投注",
  BT_CSH: "上半场波胆",
  BT_OEH: "上半场单/双",
  BT_DCH: "上半场双重机会",
  BT_FGLGH: "上半场最先进球/最后进球",
  BT_TGH: "上半场总进球",
  BT_O: "大",
  BT_U: "小",
  BT_ODD: "单",
  BT_EVEN: "双",

  BT_HDPOU: "让球&大小",
  BT_PARLAY: "混合过关",
  BT_FT: "全场",
  BT_1H: "上半场",
  BT_2H: "下半场",

  BT_FG: "最先进球",
  BT_LG: "最后进球",
  BT_HFG: "主先",
  BT_AFG: "客先",
  BT_HLG: "主后",
  BT_ALG: "客后",
  BT_NG: "无进球",
  BT_HY: "主是",
  BT_HN: "主否",
  BT_AY: "客是",
  BT_AN: "客否",
  BT_H: "主",
  BT_A: "客",
  BT_D: "和局",
  BT_HD_DC: "主 或 和局",
  BT_HA_DC: "主 或 客",
  BT_DA_DC: "客 或 和局",
  BT_HH: "主主",
  BT_HD: "主和",
  BT_HA: "主客",
  BT_DH: "和主",
  BT_DD: "和和",
  BT_DA: "和客",
  BT_AH: "客主",
  BT_AD: "客和",
  BT_AA: "客客",

  BT_Y: "是",
  BT_N: "否",

  BT_LIVE: "滚球",
  BT_HT: "半场",
  BT_DELAYED: "延迟",
  BT_PEN: "点球",

  BT_FT1: "全场.1",
  BT_FT2: "全场.2",
  BT_FTX: "全场.X",
  BT_HT1: "半场.1",
  BT_HT2: "半场.2",
  BT_HTX: "半场.X",

  BT_BOTH: "双方",
  BT_ONE: "一方",

  BS_HDP: "全场让球",
  BS_HDPH: "上半场让球",
  BS_OU: "全场大/小",
  BS_OUH: "上半场大/小",
  BS_OE: "全场单/双",
  BS_OEH: "上半场单/双",
  BS_1X2: "全场1X2",
  BS_1X2H: "上半场1X2",
  BS_ML: "全场独赢",
  BS_MLH: "上半场独赢",
  BS_1X2HDP: "全场三项让分投注",
  BS_1X2HDPH: "上半场三项让分投注",
  BS_CS: "全场波胆",
  BS_CSH: "上半场波胆",
  BS_DC: "全场双重机会",
  BS_DCH: "上半场双重机会",
  BS_FGLG: "全场最先进球/最后进球",
  BS_FGLGH: "上半场最先进球/最后进球",
  BS_TG: "全场总进球",
  BS_TGH: "上半场总进球",
  BS_ANB: "客场无效",
  BS_HTFT: "半场/全场",
  BS_BS: "双方/一方/两者皆不得分",
  BS_CL: "零失球",
  BS_DNB: "获胜球队",
  BS_DNBH: "上半场获胜球队",
  BS_HNB: "主场无效",
  BS_TWTN: "零失球的胜方",
  BS_OR: "优胜冠军",
  BS_ORZ: "优胜冠军",

  LOT_BS: "大/小",
  LOT_BIG: "大",
  LOT_SMALL: "小",
  LOT_OE: "单/双",
  LOT_ODD: "单",
  LOT_EVEN: "双",
  LOT_OU: "大/小",
  LOT_OVER: "大",
  LOT_UNDER: "小",
  LOT_FT: "全场",
  LOT_HT: "半场",

  BT_ALLBT: "所有投注类型",

  D_1: "正字",
  D_2: "正字与反字",
  D_3: "包字",
  D_4: "全保",
  D_5: "包字最后3个号码",
  D_6: "包字最后2个号码",

  D_BIG: "大",
  D_SMALL: "小",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "主",
  LOT_0: "客",

  BT_KO: "取胜方式",

  ODD_Home: "主",
  ODD_Away: "客",
  ODD_Draw: "和",
  ODD_Over: "大",
  ODD_Under: "小",
  ODD_Odd: "单",
  ODD_Even: "双",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "大 (4,5,6)",
  GH_UNDER: "小 (1,2,3)",
  GH_ODD: "单 (1,3,5)",
  GH_EVEN: "双 (2,4,6)",
  GH_OU1: "大 (4,5,6)",
  GH_OU2: "小 (1,2,3)",
  GH_OE1: "单 (1,3,5)",
  GH_OE2: "双 (2,4,6)",

  GX_1X2: "WIN",
  GX_1X20: "WIN",
  GX_1X2HDP: "PLACE/SHOW",
  GX_1X2HDP2: "PLACE",
  GX_1X2HDP4: "SHOW",
  GX_OVER: "大 (7-12)",
  GX_UNDER: "小 (1-6)",
  GX_ODD: "单 (1,3,5,7,9,11)",
  GX_EVEN: "双 (2,4,6,8,10,12)",
  GX_OU1: "大 (7-12)",
  GX_OU2: "小 (1-6)",
  GX_OE1: "单 (1,3,5,7,9,11)",
  GX_OE2: "双 (2,4,6,8,10,12)",

  GC_OU: "大/小",  
  GC_OE: "单/双",  
  GC_OVER: "大 (3,4,5)",  
  GC_UNDER: "小 (0,1,2)",  
  GC_ODD: "单 (1,3,5)",  
  GC_EVEN: "双 (0,2,4)",  
  GC_5_0: "5-0",  
  GC_4_1: "4-1",  
  GC_3_2: "3-2",  
  GC_0_5: "0-5",  
  GC_1_4: "1-4",  
  GC_2_3: "2-3",  
  GC_ML0: "第一球",  
  GC_1X20: "独赢",  
  GC_ML: "第一球",  
  GC_1X2: "独赢",  
  GC_OU1: "大 (3,4,5)",  
  GC_OU2: "小 (0,1,2)",  
  GC_OE1: "单 (1,3,5)",  
  GC_OE2: "双 (0,2,4)",

  GR_RED: "红色(1)",
  GR_YELLOW: "黄色(2)",
  GR_BLUE: "蓝色(3)",
  GR_GREEN: "绿色(4)",
  GR_OVER: "大 (3,4)",
  GR_UNDER: "小 (1,2)",
  GR_ODD: "单 (1,3)",
  GR_EVEN: "双 (2,4)",
  GR_SINGLE: "单",
  GR_PAIR: "双",
  GR_TRIPS: "三",
  GR_ADVANCED: "晋级",
  GR_ELIMINATED: "淘汰",
  GR_HIT1: "命中1",
  GR_HIT2: "命中2",
  GR_PERFECT: "完美",
  GR_MLHOME: "晋级",
  GR_MLAWAY: "淘汰",
  GR_1X2FT1: "单",
  GR_1X2FTX: "双",
  GR_1X2FT2: "三",
  GR_ML1: "晋级",
  GR_ML2: "淘汰",
  GR_1X21: "单",
  GR_1X22: "三",
  GR_1X23: "双",
  GR_OU1: "大 (3,4)",
  GR_OU2: "小 (1,2)",
  GR_OE1: "单 (1,3)",
  GR_OE2: "双 (2,4)",

  ROOM_A: "开放",
  ROOM_0: "活跃",
  ROOM_1: "关闭",
  ROOM_2: "取消",
  ROOM_3: "结束",
  ROOM_4: "停止投注",
  ROOM_10: "全部",

  ROOM_T0: "全部",
  ROOM_T1: "公共房间",
  ROOM_T2: "私人房间",
  ROOM_T3: "玩游戏赚钱",

  joinRoom1: "加入公共房间",
  joinRoom2: "加入私人房间",
  joinRoom3: "加入游戏房间",
  createRoom1: "创建公共房间",
  createRoom2: "创建私人房间",
  createRoom3: "创建游戏房间",
  Champion: "冠军",
  FirstRunnerUp: "亚军",
  SecondRunnerUp: "季军",

  BT_OEHM: "主队单双",
  BT_OEHMH: "上半场主队单双",
  BT_OEAW: "客队单双",
  BT_OEAWH: "上半场客队单双",

  BS_OEHM: "全场主队单双",
  BS_OEHMH: "上半场主队单双",
  BS_OEAW: "全场客队单双",
  BS_OEAWH: "上半场客队单双",

  MB_OVER: "大 (4,5,6)",  
  MB_UNDER: "小 (1,2,3)",  
  MB_ODD: "单 (1,3,5)",  
  MB_EVEN: "双 (2,4,6)",  

  BS_1X2OU: "胜平负 + 大小球",
  BT_1X2OU: "胜平负 + 大小球",
  BT_1O: "主胜大",
  BT_1U: "主胜小",
  BT_2O: "客胜大",
  BT_2U: "客胜小",
  BT_XO: "平局大",
  BT_XU: "平局小",

  BS_DCOU: "双重机会 + 大小球",
  BT_DCOU: "双重机会 + 大小球",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "大小球 + 单双",
  BT_OUOE: "大小球 + 单双",
  BK_OO: "大单",
  BK_OE: "大双",
  BK_UO: "小单",
  BK_UE: "小双",

  BS_HTFTOE: "半全场 + 单双",
  BT_HTFTOE: "半全场 + 单双",
  BK_EO: "半场双全场单",
  BK_EE: "半场双全场双",

  BS_WM: "获胜比分差",
  BT_WM: "获胜比分差",
  BK_H1: "主胜1球",
  BK_H2: "主胜2球",
  BK_H3Up: "主胜3+球",
  BK_A1: "客胜1球",
  BK_A2: "客胜2球",
  BK_A3Up: "客胜3+球",
  BK_D: "有进球平局(0-0除外)",
  BK_NG: "无进球",

  BS_ETG: "总进球数",
  BT_ETG: "总进球数",
  BS_EHTG: "主队总进球数",
  BT_EHTG: "主队总进球数",
  BS_EATG: "客队总进球数",
  BT_EATG: "客队总进球数",
  BS_ETGH: "上半场总进球数",
  BT_ETGH: "上半场总进球数",
  BS_EHTGH: "上半场主队进球数",
  BT_EHTGH: "上半场主队进球数",
  BS_EATGH: "上半场客队进球数",
  BT_EATGH: "上半场客队进球数",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "半场/全场 精准比分",
  BS_CSHTFT: "半场/全场 精准比分",  
  BT_ETGHTFT: "半场/全场 精准总进球",
  BS_ETGHTFT: "半场/全场 精准总进球",

  CF_CS_2_1: "2-1",
  CF_CS_2_0: "2-0",
  CF_CS_0_2: "0-2",
  CF_CS_1_2: "1-2",
  CF_R_1_W: "第一回合胜者",
  CF_R_2_W: "第二回合胜者",
  CF_R_3_W: "第三回合胜者",
  CF_MLHOME: "主队获胜",
  CF_MLAWAY: "客队获胜",
  CF_EVEN: "两回合比赛",
  CF_ODD: "三回合比赛",
  CF_ML1: "主队获胜",
  CF_ML2: "客队获胜",
  CF_ML: "独赢",
  CF_CS: "正确比分",
  CF_OE: "单双",
  CF_0: "平",
  CF_1: "主",
  CF_2: "客",
  CF_OE1: "单",
  CF_OE2: "双",
    
  EF8_R1_1STBOOM: "第一回合1st炸弹",
  EF8_R2_1STBOOM: "第二回合1st炸弹",
  EF8_R3_1STBOOM: "第三回合1st炸弹",
  EF8_0: "-",
  EF8_1: "主",
  EF8_2: "客",

};